import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Robot } from '../Robot';

const meta: Meta<typeof Robot> = {
  title: 'Components/Robot',
  component: Robot,
};

export default meta;
type Story = StoryObj<typeof Robot>;

export const Default: Story = {
  args: {},
};

export const StatusVariants: Story = {
  render() {
    return (
      <div>
        <Robot status="info" />
        <Robot status="success" />
        <Robot status="danger" />
        <Robot status="warning" />
      </div>
    );
  },
};

export const SizeVariants: Story = {
  render() {
    return (
      <div>
        <Robot status="info" size="sm" />
        <Robot status="info" size="lg" />
      </div>
    );
  },
};

export const AlternateVariants: Story = {
  render() {
    return (
      <div>
        <Robot status="info" alternate />
        <Robot status="success" alternate />
        <Robot status="danger" alternate />
        <Robot status="warning" alternate />
      </div>
    );
  },
};
